<template>
    <b-card
        no-body
        bg-variant="light"
        text-variant="dark"
        style="min-width: 200px;"
        class="mb-3 dense"
    >
        <b-card-header>
            <h4>{{ peer.serverName }}</h4>
        </b-card-header>
        <b-card-body v-if="show">
            <qr :value="peer.raw" />
        </b-card-body>
        <b-card-footer v-if="show">
            <b-button
                block
                variant="primary"
                class="mt-2"
                :href="`/api/user/peers/file/${peer.deviceName}/${peer.serverName}`"
            >
                Download file
            </b-button>
        </b-card-footer>
        <b-card-body v-if="loading">
            <Spinner text="Loading" />
        </b-card-body>
    </b-card>
</template>

<script>
    import Spinner from '@/components/general/spinner'
    import qr from '@/components/general/qr'

    export default {
        props: ['id'],
        data() {
            return {
                show: false,
                loading: false
            }
        },
        methods: {
            load() {
                this.show = false
                this.loading = true
                return this.$store
                    .dispatch('user/peers/loadByID', this.peer._id)
                    .then(() => {
                        this.show = true
                        this.loading = false
                    })
            }
        },
        created() {
            this.load()
        },
        computed: {
            peer() {
                return this.$store.getters['user/peers/getByID'](this.id)
            }
        },
        components: {
            Spinner,
            qr
        }
    }
</script>